/**
 * 下载一个文件
 * @param props
 * @usage
 * <Button onClick={e=>useDownload({ filename: 'xxx.png', url: 'https://xxx.com/xx.png'})}
 */
import { useState } from 'react';

interface Props {
  url: string;
  filename: string;
}

export const useDownload = (props: Props) => {
  const { url, filename } = props;
  const [busy, setBusy] = useState(false);
  const text = busy ? '稍候' : '下载';
  const icon = busy ? 'link' : 'download';

  return {
    text,
    icon,
    status: busy,
    command: () => {
      setBusy(true);
      fetch(url)
        .then((r) => r.blob())
        .then((res) => {
          nx.blob2down(res, { filename });
          setTimeout(() => {
            setBusy(false);
          }, 300);
        });
    },
  };
};
